import { getUserPins } from "@/services";
import imageUrl from "@/utils/imageUrl";
import Link from "next/link";
import { useCallback, useEffect, useState } from "react";
import styles from "./index.module.less";

// 包含 全部采集 的画板卡片
export default function AllPinsBoard({
  urlname,
  initPins,
  allPinsCount,
}: {
  urlname: string;
  allPinsCount: number;
  initPins?: IPin[];
}) {
  const [pins, setPins] = useState(initPins as IPin[]);

  const init = useCallback(async () => {
    // @ts-ignore
    const { err, pins } = await getUserPins({
      username: urlname,
      limit: 5,
      page: 1,
    });

    if (err) return;

    setPins(pins);
  }, [urlname]);

  useEffect(() => {
    init();
  }, [init]);

  return (
    <div
      className={styles.allPinsBoard}
      data-gd-click="button_click"
      data-button-name="全部采集的"
    >
      <Link href={`/user/${urlname}/pins`}>
        <a className={styles.cover}>
          <div className={styles.coverContainer}>
            {pins?.map((pin) => {
              const src = imageUrl(pin.file, { width: 240 });
              return (
                <div className={styles.imgWrap} key={pin.pin_id}>
                  <img className={styles.img} src={src} alt="" />
                </div>
              );
            })}

            {/* 如果采集数量小于5，则显示空图片 */}
            {Array.from({ length: 5 - pins?.length }).map((_, index) => (
              <div className={styles.emptyImg} key={index}></div>
            ))}
          </div>
        </a>
      </Link>
      <Link href={`/user/${urlname}/pins`}>
        <a className={styles.title}>全部采集的</a>
      </Link>
      <div className={styles.info}>{allPinsCount}张</div>
    </div>
  );
}
